<template>
  <el-dialog
    title="发票详情"
    :visible.sync="dialogVisible"
    width="1200px"
    class="detail"
    @open="open"
  >
    <div class="detail-head">
      <div class="flex flex-row flex-wrap">
        <div class="detail-item">
          <span>发票抬头：</span>
          <span v-if="detailInfo.htInvoiceApplyBaseinfo">
            {{ detailInfo.htInvoiceApplyBaseinfo.invoiceTitle }}
          </span>
        </div>
        <div class="detail-item">
          <span>税务证号：</span>
          <span v-if="detailInfo.htInvoiceApplyBaseinfo">
            {{ detailInfo.htInvoiceApplyBaseinfo.taxCertificate }}
          </span>
        </div>
        <div class="detail-item">
          <span>发票状态：</span>
          <span>{{
            invoiceApplyStatusMap[detailInfo.invoiceApplyStatus]
          }}</span>
        </div>
        <div class="detail-item">
          <span>开票金额：</span>
          <span>{{ detailInfo.invoiceAmount }}</span>
        </div>
        <div class="detail-item" v-if="detailInfo.invoiceApplyDismissReason">
          <span>审核驳回原因：</span>
          <span>
            {{ detailInfo.invoiceApplyDismissReason }}
          </span>
        </div>
      </div>
    </div>
    <Table :columns="columns" :data="tableData" max-height="250" border>
      <div slot="orderRanks" slot-scope="{ row }">
        <div v-for="(item, index) in row.orderRanks" :key="index">
          {{ item.productmallWaresName }}
        </div>
      </div>
    </Table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { detailInvoice } from "@/api/userCenter";
import Table from "@/components/Table";
export default {
  components: {
    Table,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    invoiceApplyId: {
      type: Number,
      default: null,
    },
    invoiceApplyStatusMap: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      columns: [
        { prop: "checkmallOrderMainId", label: "委托单号" },
        { prop: "checkmallWaresName", label: "服务名称" },
        { prop: "checkmallBusinessName", label: "商家名称" },
        { prop: "orderPrice", label: "订单金额（元）" },
        { prop: "createTime", label: "下单时间" },
      ],
      tableData: [],
      loading: false,
      detailInfo: {},
      url: "",
    };
  },

  computed: {
    dialogVisible: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    async open() {
      // 获取详情
      const data = await this.$axios.get(detailInvoice, {
        invoiceApplyId: this.invoiceApplyId,
      });
      this.detailInfo = data;
      const { checkmallOrderMainDetailList: list } = data;
      if (list && list.length) {
        this.tableData = list;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  ::v-deep .el-dialog__body {
    padding: 10px 20px;
  }
  &-head {
    position: relative;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
    margin-bottom: 10px;
  }
  &-title {
    text-align: center;
    font-size: 18px;
    font-weight: bolder;
    line-height: 1.8;
  }
  &-item {
    width: 350px;
    line-height: 40px;
  }
}
</style>
